import React from "react";

export function BreadcrumbVisual(props) {
  const {breadCrumbElements} = props;

  return (<p className={`font-lato capitalize ${props.className}`}>
      {breadCrumbElements.filter(({name}) => name).map(({name, url}, index, arr) => {
        if (url) {
          return (
            <>
              <a href={url} style={{color: index === arr.length-1 ? '#FFFFFF' : '#74757B'}}>
                {name}
              </a>
              {arr[index+1] && arr[index+1].name && (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-2 inline">
                  <path d="M4.07552 12.5685C3.91149 12.4044 3.81934 12.1819 3.81934 11.9499C3.81934 11.7179 3.91149 11.4954 4.07552 11.3313L8.40677 7.00002L4.07552 2.66877C3.91614 2.50374 3.82794 2.28271 3.82993 2.05329C3.83193 1.82387 3.92395 1.60441 4.08618 1.44218C4.24841 1.27995 4.46788 1.18792 4.6973 1.18593C4.92672 1.18394 5.14775 1.27213 5.31277 1.43152L10.2626 6.38139C10.4267 6.54548 10.5188 6.768 10.5188 7.00002C10.5188 7.23204 10.4267 7.45456 10.2626 7.61864L5.31277 12.5685C5.14869 12.7326 4.92617 12.8247 4.69415 12.8247C4.46213 12.8247 4.23961 12.7326 4.07552 12.5685Z" fill="#74757B"/>
                </svg>
              )}
            </>
          )
        }

        return (
          <span style={{color: index === arr.length-1 ? '#FFFFFF' : '#74757B'}}>{name}</span>
        )
      })}
    </p>
  )
}
